import { useContext } from 'react';
import { MEDIA_UNLOCK_FALLBACK, MediaUnlockContext } from './mediaUnlockContextValue';
/**
 * 가장 가까운 Provider의 언락 상태.
 * Provider가 없으면 preview-safe 기본값(unlocked, 스트랩 없음).
 */
export function useMediaUnlock() {
    return useContext(MediaUnlockContext) ?? MEDIA_UNLOCK_FALLBACK;
}
//# sourceMappingURL=useMediaUnlock.js.map